import React from 'react';
import { ArrowLeft } from 'lucide-react';

const steps = [
  {
    number: '1',
    title: 'اختر باقتك',
    description: 'حدد الباقة الاقتصادية أو VIP أو مقاعد الباص فقط، واختر التاريخ ونوع السكن المناسب.',
  },
  {
    number: '2',
    title: 'أرسل طلبك واتساب',
    description: 'املأ نموذج الحجز وسيتم تجهيز رسالة واتساب كاملة بتفاصيلك — أرسلها بضغطة واحدة.',
  },
  {
    number: '3',
    title: 'أكّد وانطلق',
    description: 'يرد عليك فريقنا بالتوفر والسعر وتفاصيل نقطة التجمع، ثم استعد لرحلة إيمانية مريحة.',
  },
];

const features = [
  'بدون دفع إلكتروني مسبق — التأكيد عبر واتساب',
  'رد سريع على مدار اليوم',
  'مقاعد للأفراد والعائلات والمجموعات',
];

export default function HowToBook() {
  return (
    <section id="booking" className="py-12 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-10 md:mb-16">
          <span className="inline-block bg-brown-100 text-brown-700 px-4 py-2 rounded-full text-sm font-cairo font-medium mb-4">
            كيف تحجز؟
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-amiri font-bold text-gray-900 mb-4">
            ثلاث خطوات تفصلك عن الحرم
          </h2>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Connector Line */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-12 left-0 right-0 h-0.5 bg-gray-200" style={{ width: '80%', right: '-40%' }} />
              )}
              
              <div className="relative bg-gray-50 rounded-2xl p-8 text-center hover:bg-white hover:shadow-xl transition-all border border-transparent hover:border-gray-100">
                {/* Number */}
                <div className="w-16 h-16 bg-brown-600 text-white rounded-2xl flex items-center justify-center text-2xl font-cairo font-bold mx-auto mb-6 relative z-10">
                  {step.number}
                </div>
                
                <h3 className="text-xl font-cairo font-bold text-gray-900 mb-3">{step.title}</h3>
                <p className="text-gray-600 font-cairo text-sm leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="bg-gradient-to-br from-brown-600 to-brown-800 rounded-3xl p-10 md:p-16 text-center text-white">
          <h3 className="text-2xl md:text-3xl font-amiri font-bold mb-4">
            احجز في أقل من دقيقة
          </h3>
          <p className="text-brown-100 font-cairo max-w-2xl mx-auto mb-8 leading-relaxed">
            اختر باقتك وحدد تفاصيل رحلتك، وسيتم تجهيز رسالة واتساب كاملة بكل التفاصيل — أرسلها وسيؤكد لك فريقنا التوفر والسعر مباشرة.
          </p>

          {/* Features */}
          <div className="flex flex-wrap justify-center gap-6 mb-10">
            {features.map((feature, index) => (
              <div key={index} className="flex items-center gap-2 bg-white/10 px-4 py-2 rounded-full">
                <span className="w-2 h-2 rounded-full bg-gold-300" />
                <span className="text-white font-cairo text-sm">{feature}</span>
              </div>
            ))}
          </div>

          <a
            href="https://wa.me/966575179602?text=السلام عليكم، أريد الاستفسار عن حجز رحلة عمرة من الرياض"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-white text-brown-700 px-10 py-4 rounded-xl font-cairo font-bold text-lg hover:bg-brown-50 transition-all shadow-xl"
          >
            <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
            </svg>
            احجز عبر واتساب
            <ArrowLeft size={20} />
          </a>
        </div>
      </div>
    </section>
  );
}
